import type { SpacerSdk } from "~/core";

export const isSpacer = (item: unknown): item is SpacerSdk => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "spacer"
  );
};
